import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import BookingRequestList from './BookingRequestList';
import { bookingRequest } from './BookingPropTypes';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';

class Bookings extends React.Component {

  componentWillMount() {
    if (!this.props.id && this.props.needFetch) {
      // do not get all tours when loading detail
      console.log('**** Booking Container Call request tours ********');
      // this.props.requestBookings();
    } else if (this.props.id && this.props.selectedBooking.needFetch) {
      console.log('*******Booking Container -> Detail -> Call request tour **********');
      console.log("select booking id and needfetch: ", this.props.id);
      this.props.requestBooking(this.props.id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      if (nextProps.id) {
        this.props.selectBooking(nextProps.id);
      }
    } else if (nextProps.id && nextProps.selectedBooking.needFetch) {
      this.props.requestBooking(nextProps.id);
    }
  }

  renderDetail() {
    if (this.props.selectBooking.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.selectedBooking.needFetch || this.props.selectedBooking.isFetching) {
      console.log('Booking Container needFetch...Loading detail tour');
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    console.log('Booking Container: Render BookingDetail');
    return (
      <Layout>
        <div>
          {this.props.children}
        </div>
      </Layout>
    );
  }
  renderList() {
    console.log('Render Booking List ');
    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    // if (this.props.needFetch) {
    //   return (
    //     <Layout>
    //       <Loading />
    //     </Layout>
    //   );
    // }
    return (
      <Layout>
        <div>
          <BookingRequestList requests={this.props.requests} next={this.props.next} requestBookings={this.props.requestBookings} updatePinUnpin={this.props.updatePinUnpin} editTour={this.props.editTour} getTour={this.props.getTour}/>
        </div>
      </Layout>
    );
  }
  render() {
    console.log('BookingContainer render: Booking selected: ', this.props.id);
    if (!this.props.id) {
      return this.renderList();
    }
    return this.renderDetail();
  }
}

Bookings.propTypes = {
  requests: PropTypes.arrayOf(
    PropTypes.shape({ bookingRequest }),
  ).isRequired,
  id: PropTypes.string.isRequired,
  selectedBooking: PropTypes.shape({ bookingRequest }),
  needFetch: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  selectBooking: PropTypes.func.isRequired,
  requestBookings: PropTypes.func.isRequired,
  requestBooking: PropTypes.func.isRequired,
  updatePinUnpin:  PropTypes.func.isRequired,
};

Bookings.defaultProps = {
  selectedBooking: {},
};

export default Bookings;



// WEBPACK FOOTER //
// src/routes/booking/components/Bookings.js